import React from "react";
import Spinner from "theme/components/atoms/Spinner";
import { BodyFade } from "theme/components/atoms/Typography/Body";

const LoadingArea = (props) => {
  const children =
    typeof props.children === "string" ? (
      <BodyFade>{props.children}</BodyFade>
    ) : (
      props.children
    );

  return (
    <div className="loading-area">
      <Spinner />
      {children}
    </div>
  );
};

export default LoadingArea;
